import { getAuth, signOut } from "firebase/auth";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

export function useSignOut() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return async () => {
        const auth = getAuth();

        await signOut(auth);
        queryClient.clear();
        navigate("");
    };
}
